export const LIFECYCLE_SCRIPTS = {
    READ_ONLY: "read-only",
};
